import TextEntryVariableDisplay from './TextEntryVariableDisplay';

export default TextEntryVariableDisplay;
